/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import cx from 'classnames'
import * as styles from './menu.item.styl'
import { Counter, Layout as LayoutCounter } from '../counter.menu'
import { getHtmlSelectorValueBy } from '../../../../utils/css.selector.helper'

export interface ItemProps {
  url?: string
  title: string
  counter?: any
}

export interface MenuItemProps extends ItemProps {
  selector?: string
  className?: string
  collapsedClassName?: string
  isCollapsed: boolean
}

export const CollapsedItem: React.FC<ItemProps> = ({
  counter,
  children,
  title
}: React.PropsWithChildren<ItemProps>) => (
  <>
    {counter ? <Counter layout={LayoutCounter.Marker} {...counter} /> : null}
    {children}
    <div role={'title'} className={styles.tooltipText}>
      {title}
      {counter ? (
        <Counter className={styles.tooltipCount} {...counter} />
      ) : null}
    </div>
  </>
)

export const Item: React.FC<ItemProps> = ({
  counter,
  children,
  title
}: React.PropsWithChildren<ItemProps>) => (
  <>
    {children}
    <span role={'title'} className={styles.itemText}>
      {title}
    </span>
    {counter ? <Counter {...counter} /> : null}
  </>
)

export const MenuItem: React.FC<MenuItemProps> = React.memo(
  (props: MenuItemProps) => {
    const { isCollapsed, selector, className, collapsedClassName } = props
    return (
      <div
        role={getHtmlSelectorValueBy(selector, 'menu_item_', '_', 'lower')}
        className={cx(className, selector, styles.item, {
          [cx(styles.collapsed, collapsedClassName)]: isCollapsed
        })}
      >
        <span
          className={getHtmlSelectorValueBy(`mark-app-${selector}`, '', '-')}
        />
        {isCollapsed ? <CollapsedItem {...props} /> : <Item {...props} />}
      </div>
    )
  }
)
